import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Skip Navigation Link - WCAG AAA Compliance
 * Allows keyboard users to skip to main content
 */
export const SkipNavigation: React.FC = () => {
  return (
    <a
      href="#main-content"
      className={cn(
        "sr-only focus:not-sr-only",
        "fixed top-4 left-4 z-[9999]",
        "bg-primary text-primary-foreground",
        "px-6 py-3 rounded-lg",
        "font-semibold text-sm",
        "focus-visible:ring-4 focus-visible:ring-primary/50",
        "transition-all duration-200",
        "hover:bg-primary/90"
      )}
    >
      Skip to main content
    </a>
  );
};
